var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "buildings" }, [
    _c(
      "ul",
      { staticClass: "buildings-ul" },
      [
        _vm._l(_vm.displayBuildings, function (building) {
          return _c(
            "li",
            {
              key: building.objectId,
              staticClass: "buildings-li",
              class: {
                "buildings-li-active": _vm.handleLiActive(building.objectId),
              },
            },
            [
              _c(
                "a",
                {
                  staticClass: "buildings-a",
                  attrs: { role: "button", title: building.name },
                  on: {
                    click: function ($event) {
                      return _vm.selectBuilding({
                        buildingId: building.objectId,
                      })
                    },
                  },
                },
                [
                  _vm._v(
                    _vm._s(
                      building.nameMulti[_vm.$i18n.locale] || building.name
                    )
                  ),
                ]
              ),
            ]
          )
        }),
        _vm._v(" "),
        _c("li", { staticClass: "buildings-underline" }),
      ],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }